export enum ValidationType {
	None = 'none',
	Node = 'Node',
	Function = 'Function',
  MessageType = 'MessageType'
}